module.exports = __webpack_public_path__ + "media/images/emblems/Misery-Courtion-coat_of_arms-395828f5d23d491ac97e0e60654521cf.svg";